import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 6,
  fill: "var(--smar--ursa-icons--backgroundColor, transparent)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.617 2.502a.7.7 0 0 1 .7.7v1.929a.7.7 0 0 1-.7.7h-1.929a.7.7 0 1 1 0-1.4h1.229V3.202a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1.3 8a6.7 6.7 0 0 1 12.585-3.205.7.7 0 0 1-1.229.671A5.3 5.3 0 1 0 13.301 8a.7.7 0 1 1 1.4 0A6.7 6.7 0 0 1 1.3 8",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.695 6.504a.7.7 0 0 1 .002.99l-2.48 2.489a.7.7 0 0 1-.992 0l-1.52-1.525a.7.7 0 0 1 .992-.989L7.72 8.497l1.984-1.991a.7.7 0 0 1 .99-.002",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=SyncSuccessIcon16.js.map